export const marathiFlashcards = {
  categories: [
    {
      mr: "नमस्कार",
      rm: "Namaskar",
      en: "Hello / Greetings",
    },
    {
      mr: "काय चाललंय?",
      rm: "Kaay chaalalay?",
      en: "What's up? / How's it going? (informal)",
    },
    {
      mr: "कसे आहात?",
      rm: "Kase aahat?",
      en: "How are you? (formal)",
    },
    {
      mr: "कसा आहेस?",
      rm: "Kasa aahes?",
      en: "How are you? (informal, masculine)",
    },
    {
      mr: "कशी आहेस?",
      rm: "Kashi aahes?",
      en: "How are you? (informal, feminine)",
    },
    {
      mr: "मी ठीक आहे",
      rm: "Mee thik aahe",
      en: "I am fine",
    },
    {
      mr: "धन्यवाद",
      rm: "Dhanyavaad",
      en: "Thank you",
    },
    {
      mr: "खूप धन्यवाद",
      rm: "Khoop dhanyavaad",
      en: "Thank you very much",
    },
    {
      mr: "स्वागत आहे",
      rm: "Swagat aahe",
      en: "Welcome",
    },
    {
      mr: "काही हरकत नाही",
      rm: "Kaahi harakat naahi",
      en: "You're welcome / No problem",
    },
    {
      mr: "माफ करा",
      rm: "Maaf kara",
      en: "Excuse me / Sorry",
    },
    {
      mr: "कृपया",
      rm: "Krupaya",
      en: "Please",
    },
    {
      mr: "हो",
      rm: "Ho",
      en: "Yes",
    },
    {
      mr: "नाही",
      rm: "Naahi",
      en: "No",
    },
    {
      mr: "ठीक आहे",
      rm: "Thik aahe",
      en: "Okay / Alright",
    },
    {
      mr: "मला समजले नाही",
      rm: "Mala samajle naahi",
      en: "I don't understand",
    },
    {
      mr: "तुम्ही इंग्रजी बोलता का?",
      rm: "Tumhi Ingraji bolta ka?",
      en: "Do you speak English? (formal)",
    },
    {
      mr: "तू इंग्रजी बोलतोस का?",
      rm: "Tu Ingraji boltos ka?",
      en: "Do you speak English? (informal, masculine)",
    },
    {
      mr: "तू इंग्रजी बोलतेस का?",
      rm: "Tu Ingraji boltes ka?",
      en: "Do you speak English? (informal, feminine)",
    },
    {
      mr: "हे काय आहे?",
      rm: "He kaay aahe?",
      en: "What is this?",
    },
    {
      mr: "याची किंमत किती आहे?",
      rm: "Yachi kimmat kiti aahe?",
      en: "How much is this?",
    },
    {
      mr: "कुठे आहे?",
      rm: "Kuthe aahe?",
      en: "Where is...?",
    },
    {
      mr: "शौचालय कुठे आहे?",
      rm: "Shauchalay kuthe aahe?",
      en: "Where is the toilet?",
    },
    {
      mr: "रेल्वे स्टेशन कुठे आहे?",
      rm: "Railway station kuthe aahe?",
      en: "Where is the railway station?",
    },
    {
      mr: "विमानतळ कुठे आहे?",
      rm: "Vimanatal kuthe aahe?",
      en: "Where is the airport?",
    },
    {
      mr: "मदत करा!",
      rm: "Madat kara!",
      en: "Help!",
    },
    {
      mr: "मला मदतीची गरज आहे",
      rm: "Mala madatichee garaj aahe",
      en: "I need help",
    },
    {
      mr: "मी हरवलो आहे",
      rm: "Mee haravalo aahe (m)",
      en: "I am lost (male)",
    },
    {
      mr: "मी हरवली आहे",
      rm: "Mee haravalee aahe (f)",
      en: "I am lost (female)",
    },
    {
      mr: "तुम्ही मला मदत करू शकता का?",
      rm: "Tumhi mala madat karu shakata ka?",
      en: "Can you help me? (formal)",
    },
    {
      mr: "तू मला मदत करू शकतोस का?",
      rm: "Tu mala madat karu shakatos ka?",
      en: "Can you help me? (informal, masculine)",
    },
    {
      mr: "तू मला मदत करू शकतेस का?",
      rm: "Tu mala madat karu shaktes ka?",
      en: "Can you help me? (informal, feminine)",
    },
    {
      mr: "हळू बोला",
      rm: "Halu bola",
      en: "Speak slowly",
    },
    {
      mr: "पुन्हा सांगा",
      rm: "Punha sanga",
      en: "Say it again",
    },
    {
      mr: "मी आजारी आहे",
      rm: "Mee aajari aahe",
      en: "I am sick",
    },
    {
      mr: "मला डॉक्टर हवा आहे",
      rm: "Mala doctor hava aahe",
      en: "I need a doctor",
    },
    {
      mr: "हे खूप महाग आहे",
      rm: "He khoop mahag aahe",
      en: "This is too expensive",
    },
    {
      mr: "तुम्ही किंमत कमी करू शकता का?",
      rm: "Tumhi kimmat kami karu shakata ka?",
      en: "Can you lower the price? (formal)",
    },
    {
      mr: "तू किंमत कमी करू शकतोस का?",
      rm: "Tu kimmat kami karu shakatos ka?",
      en: "Can you lower the price? (informal, masculine)",
    },
    {
      mr: "तू किंमत कमी करू शकतेस का?",
      rm: "Tu kimmat kami karu shaktes ka?",
      en: "Can you lower the price? (informal, feminine)",
    },
    {
      mr: "मला हे पाहिजे",
      rm: "Mala he pahije",
      en: "I want this",
    },
    {
      mr: "मला हे नको आहे",
      rm: "Mala he nako aahe",
      en: "I don't want this",
    },
    {
      mr: "माझे नाव... आहे",
      rm: "Majhe naav... aahe",
      en: "My name is...",
    },
    {
      mr: "तुमचं नाव काय आहे?",
      rm: "Tumch naav kaay aahe?",
      en: "What is your name? (formal)",
    },
    {
      mr: "तुझं नाव काय आहे?",
      rm: "Tujh naav kaay aahe?",
      en: "What is your name? (informal)",
    },
    {
      mr: "मी ठीक आहे, धन्यवाद",
      rm: "Mee thik aahe, dhanyavaad",
      en: "I am fine, thank you",
    },
    {
      mr: "चांगले",
      rm: "Changale",
      en: "Good",
    },
    {
      mr: "खूप चांगले",
      rm: "Khoop changale",
      en: "Very good",
    },
    {
      mr: "वाईट",
      rm: "Wait",
      en: "Bad",
    },
    {
      mr: "शुभ सकाळ",
      rm: "Shubh sakaal",
      en: "Good morning",
    },
    {
      mr: "शुभ दुपार",
      rm: "Shubh dupaar",
      en: "Good afternoon",
    },
    {
      mr: "शुभ संध्याकाळ",
      rm: "Shubh sandhyakaal",
      en: "Good evening",
    },
    {
      mr: "शुभ रात्री",
      rm: "Shubh raatri",
      en: "Good night",
    },
    {
      mr: "जातो / जाते",
      rm: "Jaato (m) / Jaate (f)",
      en: "Goodbye (male/female)",
    },
    {
      mr: "पुन्हा भेटू",
      rm: "Punha bhetu",
      en: "See you again",
    },
    {
      mr: "उजवीकडे",
      rm: "Ujvikade",
      en: "To the right",
    },
    {
      mr: "डावीकडे",
      rm: "Daavikade",
      en: "To the left",
    },
    {
      mr: "सरळ",
      rm: "Saral",
      en: "Straight ahead",
    },
    {
      mr: "जवळ",
      rm: "Javal",
      en: "Near",
    },
    {
      mr: "दूर",
      rm: "Dur",
      en: "Far",
    },
    {
      mr: "आज",
      rm: "Aaj",
      en: "Today",
    },
    {
      mr: "उद्या",
      rm: "Udya",
      en: "Tomorrow",
    },
    {
      mr: "काल",
      rm: "Kaal",
      en: "Yesterday",
    },
    {
      mr: "आता",
      rm: "Aata",
      en: "Now",
    },
    {
      mr: "नंतर",
      rm: "Nantar",
      en: "Later",
    },
    {
      mr: "पाणी",
      rm: "Paani",
      en: "Water",
    },
    {
      mr: "अन्न",
      rm: "Anna",
      en: "Food",
    },
    {
      mr: "चहा",
      rm: "Chaha",
      en: "Tea",
    },
    {
      mr: "कॉफी",
      rm: "Coffee",
      en: "Coffee",
    },
    {
      mr: "बिअर",
      rm: "Biyar",
      en: "Beer",
    },
    {
      mr: "हे शाकाहारी आहे का?",
      rm: "He shakahari aahe ka?",
      en: "Is this vegetarian?",
    },
    {
      mr: "मला भूक लागली आहे",
      rm: "Mala bhook laagalee aahe",
      en: "I am hungry",
    },
    {
      mr: "मला तहान लागली आहे",
      rm: "Mala tahaan laagalee aahe",
      en: "I am thirsty",
    },
    {
      mr: "किती वेळ लागेल?",
      rm: "Kiti vel laagel?",
      en: "How much time will it take?",
    },
    {
      mr: "पासपोर्ट",
      rm: "Passport",
      en: "Passport",
    },
    {
      mr: "व्हिसा",
      rm: "Visa",
      en: "Visa",
    },
    {
      mr: "हॉटेल",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      mr: "खोली",
      rm: "Kholi",
      en: "Room",
    },
    {
      mr: "मला एक खोली बुक करायची आहे",
      rm: "Mala ek kholi book karayachi aahe",
      en: "I want to book a room",
    },
    {
      mr: "हे खूप छान आहे",
      rm: "He khoop chhan aahe",
      en: "This is very good",
    },
    {
      mr: "काही हरकत नाही",
      rm: "Kaahi harakat naahi",
      en: "No problem",
    },
    {
      mr: "अभिनंदन!",
      rm: "Abhinandan!",
      en: "Congratulations!",
    },
    {
      mr: "शुभेच्छा!",
      rm: "Shubhechha!",
      en: "Best wishes!",
    },
    {
      mr: "मजा करा!",
      rm: "Maja kara!",
      en: "Have fun!",
    },
    {
      mr: "आत या",
      rm: "Aat yaa",
      en: "Come in",
    },
    {
      mr: "बस",
      rm: "Basa",
      en: "Sit down",
    },
    {
      mr: "उठा",
      rm: "Utha",
      en: "Get up",
    },
    {
      mr: "शांत बसा",
      rm: "Shaant basa",
      en: "Be quiet",
    },
  ],
};
